import React from 'react';

const Footer = () => {
    return (
        <div className="container-fluid footer">
            <div className="container">
                <div className="row py-2">
                    <div className="col text-center">
                        This ranking software was brought to you by Andreas Hejndorf<br />
                        If you experience any problems, feel free to contact <a href="mailto:andreas@hejndorf-foto.dk">andreas@hejndorf-foto.dk</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;